import { render, staticRenderFns } from "./addTrans.vue?vue&type=template&id=5b22b4d2"
import script from "./addTrans.vue?vue&type=script&lang=js"
export * from "./addTrans.vue?vue&type=script&lang=js"
import style0 from "./addTrans.vue?vue&type=style&index=0&id=5b22b4d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports